module.exports = __webpack_public_path__ + "static/media/01.cbe8c72a.png";